import React from 'react';
import driverIcon from '../../../../../assets/svg/driver.svg';

const NoBidders = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <img src={driverIcon} alt="" height={60} width={60} />
      <div>
        هنوز هیچ راننده ای برای این سفارش انتخاب یا پیشنهاد ارسال نکرده است.
      </div>
    </div>
  );
};

export default React.memo(NoBidders);

